import { useContext } from 'react'

import { LayoutContext } from '@provider/Shared/LayoutProvider'

import { ILayoutContext } from '@base/@types/providers/Shared/LayoutProvider'

export default function useLayout(): ILayoutContext {
  const context = useContext(LayoutContext)

  return context
}
